import React, { useState } from "react";
import moment from 'moment';
import Swal from "sweetalert2";

import {
    Button, Input, Col
} from "reactstrap";

import { useTranslation } from "react-i18next";
import * as commonFunc from 'scripts/common';


export default function ChatFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors, control } = formManager;

    // State variables holding input values and results
    const [senderNicknameInput, setSenderNicknameInput] = useState("");
    const [senderNicknameId, setSenderNicknameId] = useState(null);
    const [receiverNicknameInput, setReceiverNicknameInput] = useState("");
    const [receiverNicknameId, setReceiverNicknameId] = useState(null);


    React.useEffect(() => {
        //TEMP
        startLiveChat();
    }, []);

    // Create or retrieve Nickname objects and start LiveChat component
    const startLiveChat = () => {
        const senderNicknameName = senderNicknameInput;
        const receiverNicknameName = receiverNicknameInput;

        // Check if user informed both nicknames
        if (senderNicknameName === null || receiverNicknameName === null) {
            alert("Please inform both sender and receiver nicknames!");
            return false;
        }

        let senderNicknameObject = { id: 2, name: senderNicknameName };//TODO
        let receiverNicknameObject = { id: 3, name: senderNicknameName };//TODO

        setSenderNicknameId(senderNicknameObject.id);
        setReceiverNicknameId(receiverNicknameObject.id);
        return true;
    };

    return (
        <Col data-name="ChatFrag" data-element={data.objType} xs="12">
            <div className="container">
                {senderNicknameId === null && receiverNicknameId === null && (
                    <div>
                        <Input
                            value={senderNicknameInput}
                            onChange={(event) => setSenderNicknameInput(event.target.value)}
                            placeholder={"Sender (Your) Nickname"}
                            size="lg"
                        />
                        <Input
                            value={receiverNicknameInput}
                            onChange={(event) => setReceiverNicknameInput(event.target.value)}
                            placeholder={"Receiver (Their) Nickname"}
                            size="lg"
                        />
                        <Button
                            color="primary"
                            size="lg"
                            onClick={startLiveChat}
                        >
                            Start live chat
                        </Button>
                    </div>
                )}
                {senderNicknameId !== null && receiverNicknameId !== null && (
                    <LiveChat parentProps={props} altT={altT} t={t}
                        senderNicknameName={senderNicknameInput}
                        senderNicknameId={senderNicknameId}
                        receiverNicknameName={receiverNicknameInput}
                        receiverNicknameId={receiverNicknameId}
                    />
                )}
            </div>
        </Col>
    );
};


export const LiveChat = (props) => {
    // State variable to hold message text input
    const [results, setResults] = useState("");
    const [messageInput, setMessageInput] = useState("");
    const [waiting, setWaiting] = useState(false);

    const { register, getValues, setValue, errors, control } = props.parentProps.formManager;

    React.useEffect(() => {
        reload();
    }, []);

    const reload = () => {
        console.debug(getValues("extras.sessionId"));
        Swal.fire({
            title: props.t("gal_processing"),
            didOpen: () => { Swal.showLoading() }
        });
        setWaiting(true);

        //TEMP
        setResults([{ tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui toto a dit oui toto a dit oui toto a dit oui toto a dit oui toto a dit oui toto a dit oui toto a dit oui toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }, { tenantUserAccess: { idTenantUser: 2, name: "toto" }, dSysMod: new Date(), comments: "toto a dit oui" }, { tenantUserAccess: { idTenantUser: 3, name: "Leblanc" }, dSysMod: new Date(), comments: "Leblanc a dit non" }]);
        setWaiting(false);
        Swal.close();


        var sessionId = getValues("extras.sessionId");
        if(!commonFunc.isBlank(sessionId)) {
            var req = { sessionId: sessionId };
            commonFunc.postMethod("../api/LoadPromptFromSession", req).then((response) => {
                Swal.close();
                var data = response.data;
                if (data && data.isSuccess) {
                    setResults(data.result);
                    setWaiting(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        title: props.t("gal_fail"),
                        html: props.t("gal_error") + "<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: props.t("gal_fail"),
                html: "Aucune session associée"
            });
        }
    };

    // Message sender handler
    const sendMessage = async () => {
        try {
            const messageText = messageInput;

            let senderNicknameObject = { id: props.senderNicknameId, name: props.senderNicknameName };
            let receiverNicknameObject = { id: props.receiverNicknameId, name: props.receiverNicknameName };

            // Create new Message object and save it
            let message = { text: messageText, sender: senderNicknameObject, receiver: receiverNicknameObject }

            console.debug(getValues("extras.sessionId"));
            setWaiting(true);

            //TEMP
            Swal.close();
            reload();
            
            var sessionId = getValues("extras.sessionId");
            if (!commonFunc.isBlank(sessionId)) {
                var req = { sessionId: sessionId, message: message, waitForCompletion: true };
                commonFunc.postMethod("../api/PostLeadMessage", req).then((response) => {
                    Swal.close();
                    var data = response.data;
                    if (data && data.isSuccess) {
                        reload();
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: props.t("gal_fail"),
                            html: props.t("gal_error") + "<br/>" + response.data.errorMessage
                        });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: props.t("gal_fail"),
                    html: "Aucune session associée"
                });
            }

            // Clear input
            setMessageInput("");
        } catch (error) {
            alert(error);
        }
    };

    return (
        <div>
            <div className="flex_between">
                <h2 class="list_heading">{`${props.senderNicknameName}`}</h2>
                <div title="Reload">
                    <Button className="btn-simple btn-icon rounded-circle"
                        onClick={() => {
                            reload();
                        }}
                        color="dark"
                    ><i className="fa fa-sync"></i></Button>
                </div>
            </div>
            {results && (
                <div className="messages">
                    {results
                        .sort((a, b) => a.dSysMod > b.dSysMod)
                        .map((result) => (
                            <div
                                key={result.id}
                                className={
                                    result.tenantUserAccess.idTenantUser === props.senderNicknameId
                                        ? "message_sent"
                                        : "message_received"
                                }
                            >
                                <p className="message_name">
                                    {result.tenantUserAccess.name}
                                </p>
                                <p className="message_bubble">{result.comments}</p>
                                <p className="message_time">
                                    {moment(result.dSysMod).format("DD/MM/YYYY HH:mm")}
                                </p>
                            </div>
                        ))}
                </div>
            )}
            <div className="new_message d-flex">
                <Input type="text"
                    value={messageInput}
                    onChange={(event) => setMessageInput(event.target.value)}
                    placeholder={"Votre requête"} onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            if (!waiting) sendMessage();
                            e.preventDefault();
                        }
                    }}
                />
                {!waiting && <Button
                    className="btn-icon rounded-circle"
                    color="primary"
                    onClick={sendMessage}
                >
                    <i className="fa fa-paper-plane"></i>
                </Button>}
                {waiting && <i className="fa fa-sync fa-spin fa-xl" style={{ alignSelf: "center" }}></i>}
            </div>
        </div>
    );
};